// extracted by mini-css-extract-plugin
export default {"cls1":"xaJfGqpi42EbnnMxuJLJ","cls2":"teFkEEws1tpu06WKg9z5 xaJfGqpi42EbnnMxuJLJ"};